import { QuotesManager, ShortInterest, ShortInterestParams } from '@benzinga/quotes-manager';
import { SafeError, SafePromise } from '@benzinga/safe-await';
import { Session } from '@benzinga/session';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

export const fetchShortInterest = async (
  session: Session,
  params: ShortInterestParams = {},
): SafePromise<ShortInterest[]> => {
  try {
    const res = await session.getManager(QuotesManager).getShortInterest(params);
    if (res.err) {
      logCalendarFetchFailure('short-interest', res.err);
      return { err: res.err };
    }
    return { ok: Object.values(res.ok ?? {}).flatMap(entry => entry.data) ?? [] };
  } catch (error) {
    logCalendarFetchFailure('short-interest', error);
    const err =
      error instanceof SafeError
        ? error
        : new SafeError(error instanceof Error ? error.message : String(error), 'calendar_short_interest_fetch', error);
    return { err };
  }
};
